export function getUtmString(params: Record<string, string | null>): string {
	const defined: Record<string, string> = {};

	for (const key of Object.keys(params)) {
		const value = params[key];
		if (!value || value.length === 0) continue;

		defined[`utm_${key}`] = value;
	}

	return new URLSearchParams(defined).toString();
}
